import { Action, ActionStatus, actionStatus as actionStatusType } from 'queries/cases/types';
import { t } from 'i18next';

interface StatusCounts {
  delayed: number;
  on_track: number;
  executed: number;
  none: number;
}

const statusKeys = [
  actionStatusType.delayed,
  actionStatusType.on_track,
  actionStatusType.executed,
  actionStatusType.none,
] as const;
type StatusKey = (typeof statusKeys)[number];

export const getStatusCounts = (actions: Action[]): StatusCounts =>
  actions.reduce<StatusCounts>(
    (counts, action) => {
      const status = (action.status?.toLowerCase() ?? 'none') as StatusKey;
      return statusKeys.includes(status) ? { ...counts, [status]: counts[status] + 1 } : counts;
    },
    { delayed: 0, on_track: 0, executed: 0, none: 0 },
  );

export const getDisplayText = (actionStatus: ActionStatus): string => {
  if (actionStatus === actionStatusType.delayed)
    return t('case:status_count_panel.status.action_status.delayed');
  if (actionStatus === actionStatusType.on_track)
    return t('case:status_count_panel.status.action_status.on_track');
  if (actionStatus === actionStatusType.executed)
    return t('case:status_count_panel.status.action_status.all_executed');
  return t('case:status_count_panel.status.action_status.none');
};

export const getTooltipText = (counts: StatusCounts) => {
  const statusDetails = [
    counts.on_track > 0 && (
      <div>
        {counts.on_track} action{counts.on_track > 1 ? 's' : ''}{' '}
        <span className="on_track">
          {t('case:status_count_panel.status.action_status.on_track')}
        </span>
      </div>
    ),
    counts.delayed > 0 && (
      <div>
        {counts.delayed} action{counts.delayed > 1 ? 's' : ''}{' '}
        <span className="delayed">{t('case:status_count_panel.status.action_status.delayed')}</span>
      </div>
    ),
    counts.executed > 0 && (
      <div>
        {counts.executed} action{counts.executed > 1 ? 's' : ''}{' '}
        <span className="executed">
          {t('case:status_count_panel.status.action_status.executed')}
        </span>
      </div>
    ),
  ].filter(Boolean);

  if (statusDetails.length === 0) return null;

  return <div>{statusDetails}</div>;
};
